const zh = {
    translation: {
        "Sign in credentials": "登录凭据",
        "Sign in": "登入",
        "Add Category": "添加类别",
        "Title": "标题",
        "Description": "描述",
        "Add": "加",
        "Remove": "去掉",
        "Add/Remove": "添加/删除",
        "Success": "成功",
        "Danger": "危险",
        "Categories": "分类",
        "Image": "图片",
        "Header": "头",
        "Loading": "载入中",
        "Error": "错误",
        "Edit": "编辑",
        "Delete": "删除",
        "Edit Category": "编辑类别",
        "Save": "保存",
        "OrderID prefix": "订单ID前缀",
        "Order": "订购",
        "Email": "电子邮件",
        "Password": "密码",
        "Enable": "启用",
        "Disable": "禁用",
        "Enable/Disable": "启用/禁用",
        "Saving": "保存",
        "Paypal": "贝宝",
        "Client ID": "客户ID",
        "Client Secret": "客户秘密",
        "Sandbox": "砂箱",
        "Publishable Key": "可发布的密钥",
        "Secret Key": "密钥",
        "Delivery Charges": "送货费",
        "Price": "价钱",
        "Add Food": "添加食物",
        "Category": "类别",
        "Select": "选择",
        "Variations": "变化",
        "Type": "类型",
        "Food Image": "食物形象",
        "Foods": "食品",
        "Actions": "操作",
        "Edit Food":"编辑食物",
        "OrderID":"订单ID",
        "Orders":"命令",
        "Name":"名称",
        "Items":"项目",
        "Payment":"付款",
        "Status":"状态",
        "Review":"评论",
        "Mark as":"标记为",
        "Users":"用户",
        "Phone":"电话",
        "Address":"地址",
        "2019":"2019",
        "About Us":"关于我们",
        "Blog":"博客",
        "Welcome":"欢迎",
        "Logout":"登出",
        "Dashboard":"仪表板",
        "Configuration":"组态",
        "Login":"登录",
        "Food":"餐饮",
        "Character limit of max length 50":"最大长度50的字符限制",
        "Character limit of max length 15":"最大长度15的字符限制",
        "Character limit of max length 60":"最大长度60的字符限制",
        "Character limit of max length 20":"最大长度20的字符限制",
        "Character limit of max length 140":"最大长度的字符限制140",
        "Currency": "货币",
        "Currency Code": "货币代码",
        "Currency Symbol": "货币符号",
    }
}
export default zh